import React from 'react';
import BaseIcon from '../base-icon';

const StarFilled = (props) => (
  <BaseIcon viewBox="2 2 24 24" {...props} scalable>
    <path d="M23.42 11.73a.47.47 0 00-.4-.33l-5.88-.86-2.69-5.27a.53.53 0 00-.9 0l-2.69 5.27L5 11.4a.47.47 0 00-.4.33.5.5 0 00.11.51L9 16.65l-1.12 5.76a.5.5 0 00.2.49.49.49 0 00.53 0L14 20.12l5.39 2.82a.49.49 0 00.23.06.47.47 0 00.3-.1.5.5 0 00.2-.49L19 16.65l4.3-4.41a.5.5 0 00.12-.51z" />
  </BaseIcon>
);

export default StarFilled;
